var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.img_types.includes(_vm.fileType) ? _c('img', {
    attrs: {
      "src": _vm.url
    }
  }) : _c('LogoFallback');
}
var staticRenderFns = []

export { render, staticRenderFns }